let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("chSl3")).then(() => parcelRequire('70BBu'));